import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from 'react-router-dom';
import { connect } from "react-redux";
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { upperFirst } from 'lodash';

import AppService from '../services/AppService';
import clsx from "clsx";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import { MainListItems } from "../navigation/listItems";
import Drawer from "@material-ui/core/Drawer";
import { Avatar, CssBaseline } from "./shared/MaterialUI";
import logo from "../assets/images/logo.png";
import { Grid, Menu, MenuItem } from "@material-ui/core";
import { AccountCircleOutlined } from "@material-ui/icons";
import { ExpandMore } from "@material-ui/icons";
import { WizardStyles } from "../assets/css/wizard-style";
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';

const Header = (props) => {
  const [, setHasError] = useState({});
  const [requestFailed, setRequestFailed] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);

  const [open, setOpen] = React.useState(false);
  const toggleDrawer = () => {
    setOpen(!open);
  };

  const history = useHistory();
  const classes = useStyles();
  const wizardStyle = WizardStyles();

  const accessToken = props.user.accessToken;
  const firstName = props.user.firstName;
  const title = props.title;

  const appService = new AppService();
  const menuId = 'primary-search-account-menu';

  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    if (!setRequestFailed) {
      setHasError("");
    }
  }, [requestFailed]);

  const logout = async () => {
    try {
      setRequestFailed(false);
      appService.setAccessToken(accessToken);
      props.dispatch({ type: 'LOGOUT' });
      history.push('/login');
    } catch (e) {
      setRequestFailed(true);
      setHasError({ message: e.response.data.message });
    }
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={() => { logout() }}>Logout</MenuItem>
    </Menu>
  );

  return (
    <>
      <CssBaseline />
      <AppBar position="absolute"
        className={clsx(classes.appBar, open && classes.appBarShift)}>
        <Toolbar className={classes.toolbar}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={toggleDrawer}
            className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
          >
            <Avatar alt="Mow Managers" src={logo} />
            <Divider orientation="vertical" flexItem />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            {currentPath !== '/profile' && (upperFirst(title))}
            {currentPath === '/profile' && (
              <IconButton
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  history.goBack();
                }}
              >
                <KeyboardBackspaceIcon />
                <span style={{ fontSize: '20px', lineHeight: '20px', }}> back</span>
              </IconButton>
            )}
          </Typography>
          <div className={wizardStyle.wrapperLogout}>
            <span>Hi! </span>
            <span className={wizardStyle.title}>{firstName}!</span>
            <IconButton
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              color="inherit"
            >
              <AccountCircleOutlined />
            </IconButton>
            <IconButton
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <ExpandMore />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
        }}
        open={open}
        color="primary"
      >
        <div className={classes.toolbarIcon}>
          {open && (<Grid container alignItems="center">
            <IconButton onClick={toggleDrawer}>
              <Avatar alt="Mow Managers" src={logo} />
            </IconButton>
            <Divider orientation="vertical" flexItem />
            <IconButton onClick={toggleDrawer}>
              <ArrowBackIcon style={{ color: '#FFFFFF', fontSize: '20px' }} />
              <span style={{ margin: '4px', color: '#FFFFFF', fontSize: '20px' }}>Overview</span>
            </IconButton>
          </Grid>)}
        </div>
        <Divider />
        <List color="primary"><MainListItems /></List>
        {/*<Divider/>
        <List><SecondaryListItems></List>*/}
      </Drawer>
      {renderMenu}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.user
  };
};

export default connect(mapStateToProps)(Header);
const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  title: {
    flexGrow: 1,
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
    backgroundColor: "#10AA39",
  },
  toolbarIcon: {
    background: "#28292E",
    color: "#FFFFFF",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - 240px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: 'border-box',
    background: "#0B0C0E",
    color: "#FFFFFF",
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
    background: "#0B0C0E",
    color: "#FFFFFF",
  }
}));
